module.exports = __webpack_public_path__ + "static/media/hifiman-he4xx.8abac26c.png";